import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Fills the right-hand detail column on wide screens (see MasterDetailGrid)
 * when nothing is selected yet.
 */
export const MasterDetailEmptyState = ({ Icon, title, description, className }) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border bg-[hsl(var(--muted))]/30 p-10 text-center xl:sticky xl:top-6 xl:min-h-[240px]',
      className
    )}
  >
    {Icon ? <Icon size={28} className="mb-1 text-muted-foreground/40" /> : null}
    <div className="text-sm font-medium text-foreground">{title}</div>
    {description ? (
      <div className="max-w-[220px] text-xs text-muted-foreground">{description}</div>
    ) : null}
  </div>
);

export default MasterDetailEmptyState;
